import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'RMA No',
     label: 'RMA No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rmaDate',
     field: FIELDS.RMADATE,
     title: 'RMA Date',
     label: 'RMA Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rmaActionName',
     field: FIELDS.RMAACTION_NAME,
     title: 'Actions',
     label: 'Actions',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rmaTermsName',
     field: FIELDS.RMATERMS_NAME,
     title: 'Terms',
     label: 'Terms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress',
     field: FIELDS.BILLING_ADDRESS,
     title: 'Bill To',
     label: 'Bill To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress',
     field: FIELDS.SHIPPING_ADDRESS,
     title: 'Ship To',
     label: 'Ship To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'Sub Total',
     label: 'Sub Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Tax',
     label: 'Total Charges Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non Tax',
     label: 'Total Charges Non Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'approvedByUserFullName',
     field: FIELDS.APPROVED_BY_USER_FULL_NAME,
     title: 'Approved By',
     label: 'Approved By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'returnShipping',
     field: FIELDS.RETURN_SHIPPING,
     title: 'Return Shipping',
     label: 'Return Shipping',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalNoCharge',
     field: FIELDS.TOTAL_NO_CHARGE,
     title: 'Total No Charge',
     label: 'Total No Charge',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxDescription',
     field: FIELDS.TAX_DESCRIPTION,
     title: 'Tax Description',
     label: 'Tax Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Subtotal Conv',
     label: 'Subtotal Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Conv',
     label: 'Total Line Cost Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Tax Conv',
     label: 'Total Charges Tax Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Tax Conv',
     label: 'Total Charges Non Tax Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Conv',
     label: 'Total Charges Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Conv',
     label: 'Total Charges Cost Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Conv',
     label: 'Total Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxable',
     field: FIELDS.TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'invoiceAmountPaid',
     field: FIELDS.INVOICE_AMOUNT_PAID,
     title: 'Invoice Amount Paid',
     label: 'Invoice Amount Paid',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'invoiceBalance',
     field: FIELDS.INVOICE_BALANCE,
     title: 'Invoice Balance',
     label: 'Invoice Balance',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch Rate',
     label: 'Exch Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Authorized',
     label: 'Date Authorized',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
